import { createTheme } from "@mui/material/styles";

// VEYSO palette: five hues, each with a base and four lighter tints (index 0 is the base).
export const palette5 = {
  basalt: ["#29271A", "#453B2F", "#73624E", "#A0886C", "#C2B5A5"],
  navy: ["#2E4A6F", "#406BA0", "#6E98CA", "#85B7F4", "#B9D9FF"],
  moss: ["#606A4F", "#83926B", "#A4B686", "#C0D1A7", "#DBE3CB"],
  oxide: ["#C35731", "#E06F47", "#EE8661", "#FFA281", "#FFBFA9"],
  gold: ["#E28E2E", "#E7A050", "#F7B569", "#FECA90", "#FED9AD"],
};

// Design tokens. Existing component code uses these names; change colors here.
export const tokens = {
  ink: "#211F14",
  muted: "#6A6050",
  forest: palette5.navy[0],      // accent text and links
  forestDark: "#2A2820",         // footer and dark sections (deep basalt)
  sage: "#E4E8D9",               // soft moss section background
  cream: "#FAF7F2",              // page background (Figma "ivory")
  sand: "#EFE6DC",               // alternate section background
  brown: "#3A281E",              // dark brand band
  mossBtn: "#606E52",            // calm action color (Add to cart, Join)
  paper: "#FFFFFF",
  line: "#E6DFD0",
  coral: "#C4572F",              // primary action color (iron oxide, from Figma)
  oxide: "#C4572F",
  oxideHover: "#A94A27",
  gold: palette5.gold[0],
  inRange: palette5.moss[0],
  watch: palette5.gold[0],
  outRange: "#B8432B",
};

export const fonts = {
  display: '"Satoshi", "Inter", system-ui, -apple-system, "Segoe UI", sans-serif',
  body: '"Satoshi", "Inter", system-ui, -apple-system, "Segoe UI", sans-serif',
};

// Gradient backdrops for the big hero panels, one per area of the site.
export const heroThemes = {
  basalt: {
    bg: "radial-gradient(90% 80% at 88% 12%, rgba(160,136,108,.55) 0%, rgba(160,136,108,0) 60%), linear-gradient(160deg,#1C130B 0%,#3B2A1E 50%,#6B5040 100%)",
    cta: palette5.oxide[0], ctaHover: palette5.oxide[1], eyebrow: palette5.basalt[4],
  },
  navy: {
    bg: "linear-gradient(180deg,#0E2342 0%,#2E4A6F 42%,#5A96AE 100%)",
    cta: "#223A5E", ctaHover: "#1A2E4C", eyebrow: palette5.navy[4],
  },
  moss: {
    bg: "radial-gradient(80% 80% at 62% 58%, rgba(124,136,56,.85) 0%, rgba(124,136,56,0) 62%), linear-gradient(135deg,#142218 0%,#2F3F2C 50%,#5A6548 100%)",
    cta: palette5.moss[2], ctaHover: palette5.moss[3], ctaText: "#1B2615", eyebrow: palette5.moss[3],
  },
  gold: {
    bg: "radial-gradient(80% 90% at 85% 20%, rgba(254,202,144,.55) 0%, rgba(254,202,144,0) 60%), linear-gradient(150deg,#3A2A12 0%,#9A5D18 58%,#E28E2E 100%)",
    cta: palette5.oxide[0], ctaHover: palette5.oxide[1], eyebrow: palette5.gold[3],
  },
};

const theme = createTheme({
  palette: {
    primary: { main: tokens.oxide, dark: tokens.oxideHover, contrastText: "#fff" },
    secondary: { main: palette5.navy[0] },
    text: { primary: tokens.ink, secondary: tokens.muted },
    background: { default: tokens.cream, paper: tokens.paper },
  },
  shape: { borderRadius: 16 },
  typography: {
    fontFamily: fonts.body,
    h1: { fontFamily: fonts.display, fontWeight: 300, letterSpacing: "-0.03em" },
    h2: { fontFamily: fonts.display, fontWeight: 300, letterSpacing: "-0.025em" },
    h3: { fontFamily: fonts.display, fontWeight: 400, letterSpacing: "-0.02em" },
    h4: { fontFamily: fonts.display, fontWeight: 500, letterSpacing: "-0.01em" },
    button: { textTransform: "none", fontWeight: 500 },
  },
  components: {
    MuiButton: {
      styleOverrides: { root: { borderRadius: 999, paddingInline: 24, boxShadow: "none" } },
    },
    MuiCssBaseline: {
      styleOverrides: {
        "@keyframes veysoMarquee": { from: { transform: "translateX(0)" }, to: { transform: "translateX(-50%)" } },
        "@media (prefers-reduced-motion: reduce)": { "*": { animationDuration: "0.01ms !important", animationIterationCount: "1 !important" } },
      },
    },
  },
});

export default theme;
